/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Admin_Footer_Badges_Code_HelpInputs */

const en_admin_footer_badges_code_help = /** @type {(inputs: Admin_Footer_Badges_Code_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paste an HTTPS image badge or text link. Styles and wrappers are safely removed. Maximum ${i?.max}.`)
};

/**
* | output |
* | --- |
* | "Paste an HTTPS image badge or text link. Styles and wrappers are safely removed. Maximum {max}." |
*
* @param {Admin_Footer_Badges_Code_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_code_help = /** @type {((inputs: Admin_Footer_Badges_Code_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Code_HelpInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_code_help(inputs)
});
export { admin_footer_badges_code_help as "admin.footer_badges.code_help" }